import { InjectionToken } from "@angular/core";

export const ARTIST_ROUTES = [
  "confirm",
  "statistics",
  "promotions",
  "guides",
  "image-manager",
];

enum AppRoles {
  USER = "USER",
  ADMIN = "ADMIN",
}

export interface ModuleConfig {
  ROUTING?: {
    PATH?: any;
    VIEW?: any;
  };
}

export interface AppConfig extends ModuleConfig {
  TITLE: string;
  DEFAULT_LANGUAGE: string;
  ROLES: any;
}

export const APP_CONSTANTS: AppConfig = {
  TITLE: "SlashMobility Seed",
  DEFAULT_LANGUAGE: "en",
  ROUTING: {
    PATH: {
      EMPTY: "",
      ROOT: "/",
      LOGIN: "/login",
      HOME: "/home",
      UNAUTHORIZED_REDIRECT: "/login",
      UNAUTHORIZED_GUEST_REDIRECT: "/home",
      AUTH_ERROR_REDIRECTION: "/login",
    },
    VIEW: {
      EMPTY: "",
      LOGIN: "login",
      SIGNUP: "signup",
      HOME: "home",
    },
  },
  ROLES: AppRoles,
};
export const READ_WHY_OPT: any = {
  MIN_ITEMS_ACCEPTED: 30,
  MIN_ITEM_IN_SHOWCASE: 20
};

export let APP_CONFIG = new InjectionToken<AppConfig>("app.config");
